import React, { useEffect } from 'react';
import { Grid, Box } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';

import '../../assets/css/dashboard.css';
import '../../assets/css/nova-dashboard.css';
import TotalDemandasPorEquipe from './components/TotalDemandasPorEquipe';
import ProcedimentosIncluidosDemanda from './components/ProcedimentosIncluidosDemanda';
import QuantidadeEletivoVsUrgencia from './components/QuantidadeEletivoVsUrgencia';
import QuantidadePedidosFinalizados from './components/QuantidadePedidosFinalizados';
import QuantidadePedidosIncluidos from './components/QuantidadePedidosIncluidos';
import QuantidadeDemandasCadastradas from './components/QuantidadeDemandasCadastradas';
import DemandaConvertidaPedido from './components/DemandaConvertidaPedido';
import ProcedimentosRealizadosPorEquipe from './components/ProcedimentosRealizadosPorEquipe';
import TotalDemandasPedidosCirurgiasIncluidos from './components/TotalDemandasPedidosCirurgiasIncluidos';
import ModalQuantidadeEletivoVsUrgencia from './components/modals/ModalQuantidadeEletivoVsUrgencia';
import ModalDemandaConvertidaPedido from './components/modals/ModalDemandaConvertidaPedido';
import ModalProcedimentosRealizadosPorEquipe from './components/modals/ModalProcedimentosRealizadosPorEquipe';
import ModalProcedimentosIncluidosDemanda from './components/modals/ModalProcedimentosIncluidosDemanda';
import ModalTotalDemandasPorEquipe from './components/modals/ModalTotalDemandasPorEquipe';

import { dominioDemandaCirurgica } from '../../config/database';

export default function SpacingGrid() {
  const [profissional, setProfissional] = React.useState({});
  const [equipes, setEquipes] = React.useState([]);
  const [equipesSelecionadas, setEquipesSelecionadas] = React.useState([]);
  const [botoesCentroCirurgico, setBotoesCentroCirurgico] = React.useState([]);
  const [abrirDialog, setAbrirDialog] = React.useState(false);
  const [centroCirurgicosSelecionados, setCentroCirurgicosSelecionados] = React.useState([]);
  const [centrosCirurgicosFiltrados, setCentrosCirurgicosFiltrados] = React.useState([]);
  const [opcaoModal, setOpcaoModal] = React.useState(0);
  const [dataInicio, setDataInicio] = React.useState(
    new Date(new Date().setMonth(new Date().getMonth() - 3))
  );
  const [dataFim, setDataFim] = React.useState(new Date());
  const [eOnco, setEOnco] = React.useState('2');

  const listaModal = [
    <ModalQuantidadeEletivoVsUrgencia
      key="modalQuantidadeEletivoVsUrgencia"
      equipes={equipesSelecionadas}
      centrosCirurgicos={centroCirurgicosSelecionados}
      dataInicio={dataInicio}
      dataFim={dataFim}
      eOnco={eOnco}
    />,
    <ModalDemandaConvertidaPedido
      key="modalDemandaConvertidaPedido"
      equipes={equipesSelecionadas}
      centrosCirurgicos={centroCirurgicosSelecionados}
      dataInicio={dataInicio}
      dataFim={dataFim}
      eOnco={eOnco}
    />,
    <ModalProcedimentosRealizadosPorEquipe
      key="modalProcedimentosRealizadosPorEquipe"
      equipes={equipesSelecionadas}
      centrosCirurgicos={centroCirurgicosSelecionados}
      dataInicio={dataInicio}
      dataFim={dataFim}
      eOnco={eOnco}
    />,
    <ModalProcedimentosIncluidosDemanda
      key="modalProcedimentosIncluidosDemanda"
      equipes={equipesSelecionadas}
      centrosCirurgicos={centroCirurgicosSelecionados}
      dataInicio={dataInicio}
      dataFim={dataFim}
      eOnco={eOnco}
    />,
    <ModalTotalDemandasPorEquipe
      key="modalTotalDemandasPorEquipe"
      equipes={equipesSelecionadas}
      centrosCirurgicos={centroCirurgicosSelecionados}
      dataInicio={dataInicio}
      dataFim={dataFim}
      eOnco={eOnco}
    />,
  ];

  const myToast = React.useRef(null);

  const renderBotoesCentroCirurgico = () => {
    const profissionalLogado = JSON.parse(localStorage.getItem('profissional'));
    if (profissionalLogado.centrosCirurgicos.length <= 1) {
      setBotoesCentroCirurgico([]);
      setCentroCirurgicosSelecionados([]);
      return;
    }

    const botoes = [];
    dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
      response.data.forEach(centroCirurgico => {
        if (profissionalLogado.centrosCirurgicos.includes(centroCirurgico.id))
          botoes.push({
            id: centroCirurgico.id,
            departamento: centroCirurgico.departamento,
          });
      });

      setBotoesCentroCirurgico(botoes);
      setCentroCirurgicosSelecionados(botoes);
    });
  };

  const carregaEquipes = () => {
    dominioDemandaCirurgica.get('/api/equipesAtivas').then(response => {
      setEquipes(response.data);
    });
  };

  const carregaAPITotalPedido = () => {
    dominioDemandaCirurgica.get('/api/apiTotalPedido').then(response => {
      return response.data;
    });
  };

  const carregaAPITotalDemanda = () => {
    dominioDemandaCirurgica.get('/api/apiTotalDemanda').then(response => {
      return response.data;
    });
  };

  const carregaDatasFiltros = () => {
    setDataFim(new Date());
    setDataInicio(new Date(new Date().setMonth(new Date().getMonth() - 3)));
  };

  const handleClickBotaoCentroCirurgico = centroCirurgico_id => {
    let centrosCirurgicosFiltradosAux = centrosCirurgicosFiltrados;
    if (centrosCirurgicosFiltradosAux.includes(centroCirurgico_id)) {
      if (centrosCirurgicosFiltradosAux.length === 1) return;
      centrosCirurgicosFiltradosAux = centrosCirurgicosFiltradosAux.filter(
        id => id !== centroCirurgico_id
      );
      setCentrosCirurgicosFiltrados(centrosCirurgicosFiltradosAux);
    } else {
      centrosCirurgicosFiltradosAux.push(centroCirurgico_id);
      setCentrosCirurgicosFiltrados(centrosCirurgicosFiltradosAux);
    }
  };

  const handleValidaDataInicio = data => {
    if (!data) {
      myToast.current.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'A Data Início não pode ser vazia',
        life: 10000,
      });
      setDataInicio(new Date(new Date().setMonth(new Date(dataFim).getMonth() - 3)));
    } else if (data < new Date(new Date().setMonth(new Date(dataFim).getMonth() - 6))) {
      myToast.current.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'O limite máximo de filtragem de data é de 6 meses!',
        life: 10000,
      });
      setDataInicio(new Date(new Date().setMonth(new Date(dataFim).getMonth() - 6)));
    } else if (data > dataFim) {
      myToast.current.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'A Data Início não pode ser maior que a Data Fim',
        life: 10000,
      });
      setDataInicio(new Date(new Date().setMonth(new Date(dataFim).getMonth() - 3)));
    } else setDataInicio(data);
  };

  const handleValidaDataFim = data => {
    if (!data) {
      myToast.current.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'A Data Fim não pode ser vazia',
        life: 10000,
      });
      setDataFim(new Date(new Date().setMonth(new Date(dataInicio).getMonth() + 3)));
    } else if (data > new Date(new Date().setMonth(new Date(dataInicio).getMonth() + 6))) {
      myToast.current.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'O limite máximo de filtragem de data é de 6 meses!',
        life: 10000,
      });
      setDataFim(new Date(new Date().setMonth(new Date(dataInicio).getMonth() - 6)));
    } else if (data < dataInicio) {
      myToast.current.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'A Data Fim não pode ser menor que a Data Início',
        life: 10000,
      });
      setDataFim(new Date(new Date().setMonth(new Date(dataInicio).getMonth() + 3)));
    } else setDataFim(data);
  };

  const handleOncologia = async () => {
    if (eOnco === '2') {
      await setEOnco('1');
    } else {
      await setEOnco('2');
    }
  };

  const handleAbreModalQuantidadeEletivoVsUrgencia = () => {
    setOpcaoModal(0);
    setAbrirDialog(true);
  };

  const handleAbreModalDemandaConvertidaPedido = () => {
    setOpcaoModal(1);
    setAbrirDialog(true);
  };

  const handleAbreModalProcedimentosRealizadosPorEquipe = () => {
    setOpcaoModal(2);
    setAbrirDialog(true);
  };

  const handleAbreModalProcedimentosIncluidosDemanda = () => {
    setOpcaoModal(3);
    setAbrirDialog(true);
  };

  const handleAbreModalTotalDemandasPorEquipe = () => {
    setOpcaoModal(4);
    setAbrirDialog(true);
  };

  useEffect(() => {
    setProfissional(JSON.parse(localStorage.getItem('profissional')));
    setCentrosCirurgicosFiltrados(
      JSON.parse(localStorage.getItem('profissional')).centrosCirurgicos
    );
    renderBotoesCentroCirurgico();
    carregaEquipes();
    carregaDatasFiltros();
    carregaAPITotalPedido();
    carregaAPITotalDemanda();
  }, []);

  return (
    <>
      <Toast ref={myToast} />

      <Dialog
        // header="Atenção"
        visible={abrirDialog}
        modal
        blockScroll
        style={{ width: '70%' }}
        className="modal-responsive"
        // footer={renderFooterDisplayConfirmacaoResetaPaciente()}
        onHide={() => setAbrirDialog(false)}
      >
        {listaModal[opcaoModal]}
      </Dialog>

      <Box margin={1} display="flex" flexDirection="column">
        <Grid container spacing={1}>
          <Grid container item justifyContent="center" xs={12} md={12} spacing={1}>
            <div className="buttons-centros-cirurgicos">
              <SelectButton
                value={centroCirurgicosSelecionados}
                options={botoesCentroCirurgico}
                onChange={e => setCentroCirurgicosSelecionados(e.value)}
                optionLabel="departamento"
                multiple
              />
            </div>
            <Grid item xs={12} md={4}>
              <Autocomplete
                fullWidth
                multiple
                id="tags-standard"
                options={equipes}
                getOptionLabel={option => option.descricao}
                onChange={(e, values) => {
                  setEquipesSelecionadas(values);
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="standard"
                    label="Equipes"
                    style={{
                      backgroundColor: 'white',
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                    }}
                    placeholder="Selecione uma ou mais equipes"
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} md={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                <KeyboardDatePicker
                  inputProps={{ onKeyDown: e => e.preventDefault() }}
                  fullWidth
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  id="date-picker-inline"
                  autoOk
                  value={dataInicio}
                  onChange={handleValidaDataInicio}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  style={{
                    backgroundColor: 'white',
                    height: '100%',
                    justifyContent: 'center',
                    paddingLeft: 8,
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6} md={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                <KeyboardDatePicker
                  inputProps={{ onKeyDown: e => e.preventDefault() }}
                  fullWidth
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  id="date-picker-inline"
                  autoOk
                  value={dataFim}
                  onChange={handleValidaDataFim}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  style={{
                    backgroundColor: 'white',
                    height: '100%',
                    justifyContent: 'center',
                    paddingLeft: 8,
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6} md={1}>
              <Button
                label="ONCO"
                key={1}
                style={{
                  height: '48px',
                  fontWeight: 'bold',
                }}
                className={
                  eOnco === '1'
                    ? 'button-oncologia-dashboard'
                    : 'button-oncologia-dashboard-desabilitado'
                }
                onClick={() => handleOncologia()}
              />
            </Grid>
          </Grid>

          <Grid container item xs={12}>
            <Grid item xs={12} spacing={1}>
              <TotalDemandasPedidosCirurgiasIncluidos
                equipes={equipesSelecionadas}
                centrosCirurgicos={centroCirurgicosSelecionados}
                dataInicio={dataInicio}
                dataFim={dataFim}
              />
            </Grid>
          </Grid>

          <Grid container item xs={12}>
            <Grid container item flexDirection="row" spacing={1} xs={12} sm={12} md={12}>
              <Grid item xs={6} sm={4} md={2}>
                <QuantidadeDemandasCadastradas
                  equipes={equipesSelecionadas}
                  centrosCirurgicos={centroCirurgicosSelecionados}
                  dataInicio={dataInicio}
                  dataFim={dataFim}
                  eOnco={eOnco}
                />
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <QuantidadePedidosIncluidos
                  equipes={equipesSelecionadas}
                  centrosCirurgicos={centroCirurgicosSelecionados}
                  dataInicio={dataInicio}
                  dataFim={dataFim}
                  eOnco={eOnco}
                />
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <QuantidadePedidosFinalizados
                  equipes={equipesSelecionadas}
                  centrosCirurgicos={centroCirurgicosSelecionados}
                  dataInicio={dataInicio}
                  dataFim={dataFim}
                  eOnco={eOnco}
                />
              </Grid>
              <Grid
                item
                xs={6}
                sm={4}
                md={2}
                onClick={() => handleAbreModalQuantidadeEletivoVsUrgencia()}
              >
                <QuantidadeEletivoVsUrgencia
                  equipes={equipesSelecionadas}
                  centrosCirurgicos={centroCirurgicosSelecionados}
                  dataInicio={dataInicio}
                  dataFim={dataFim}
                  eOnco={eOnco}
                />
              </Grid>
              <Grid
                item
                xs={6}
                sm={4}
                md={2}
                onClick={() => handleAbreModalDemandaConvertidaPedido()}
              >
                <DemandaConvertidaPedido
                  equipes={equipesSelecionadas}
                  centrosCirurgicos={centroCirurgicosSelecionados}
                  dataInicio={dataInicio}
                  dataFim={dataFim}
                  eOnco={eOnco}
                />
              </Grid>
              <Grid
                item
                xs={6}
                sm={4}
                md={2}
                onClick={() => handleAbreModalProcedimentosRealizadosPorEquipe()}
              >
                <ProcedimentosRealizadosPorEquipe
                  equipes={equipesSelecionadas}
                  centrosCirurgicos={centroCirurgicosSelecionados}
                  dataInicio={dataInicio}
                  dataFim={dataFim}
                  eOnco={eOnco}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container item md={12}>
            <Grid container item justifyContent="center" spacing={1}>
              <Grid
                item
                xs={12}
                md={6}
                onClick={() => handleAbreModalProcedimentosIncluidosDemanda()}
              >
                <ProcedimentosIncluidosDemanda
                  equipes={equipesSelecionadas}
                  centrosCirurgicos={centroCirurgicosSelecionados}
                  dataInicio={dataInicio}
                  dataFim={dataFim}
                  eOnco={eOnco}
                />
              </Grid>
              <Grid item xs={12} md={6} onClick={() => handleAbreModalTotalDemandasPorEquipe()}>
                <TotalDemandasPorEquipe
                  equipes={equipesSelecionadas}
                  centrosCirurgicos={centroCirurgicosSelecionados}
                  dataInicio={dataInicio}
                  dataFim={dataFim}
                  eOnco={eOnco}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
